module.exports = __webpack_public_path__ + "static/ClearTrace-cfec38131409c33061e7c732fc98ac4c.jpg";